import { HttpResponse, http } from 'msw';

import { environment } from '../../environments/environment';

const env = { ...environment };
const module = env.services.productTag;
const envServiceUrl = module.url;

// Default: มีป้ายอายุสั้นรอพิมพ์ 18 ป้าย จากการทำรับวันที่ 01/06/2026
// ตั้ง numberOfTags เป็น 0 เพื่อดู empty state "ไม่มีป้ายรอพิมพ์"
const countShortLivedTag = () =>
  HttpResponse.json({
    numberOfTags: 18,
    receiveDate: '2026-06-01',
    shortLivedProductsPrint: [
      { id: 1, qty: 10 },
      { id: 2, qty: 8 }
    ]
  });

const validateShortLivedTag = () => new HttpResponse(null, { status: 204 });
const submitShortLivedTag = () => new HttpResponse(null, { status: 204 });

// สลับมาใช้แทน validateShortLivedTag/submitShortLivedTag เพื่อทดสอบ modal "ข้อมูลมีการเปลี่ยนแปลง"
const _shortLivedTagDataChanged = () =>
  HttpResponse.json(
    { code: '00003', message: 'The current session is no longer because data has been changed.' },
    { status: 400 }
  );

// ป้าย RTC — BE ประกอบค่าให้ตรงกับ input ของ thermal-printer-lib มาแล้ว (ตัวเลขไม่มีคอมมา, วันที่ DD/MM/YY,
// uniqueNumber 16 ตัวอักษร, expirationDateTime 14 หลัก) ถ้าแก้ mock ต้องคงรูปแบบนี้ ไม่งั้น lib จะ throw
const printInfoRtcTag = () =>
  HttpResponse.json([
    {
      productName: 'นมสดพาสเจอร์ไรส์ รสจืด ขนาด 200 มล.',
      unit: 'ขวด',
      retailPrice: '1250',
      clearPrice: '899',
      expirationDate: '27/08/26',
      uniqueNumber: '9406847509251.00',
      expirationDateTime: '27082026235959',
      printQty: 2
    }
  ]);

const markPrintedRtcTag = () => new HttpResponse(null, { status: 204 });

// สลับมาใช้แทน printInfoRtcTag เพื่อทดสอบ modal "ข้อมูลมีการเปลี่ยนแปลง" — BE ตอบได้ทั้ง 2 code นี้
const _rtcTagDataChanged = () =>
  HttpResponse.json(
    {
      code: 'DATA_HAS_BEEN_CHANGED',
      message: 'The current session is no longer valid because data has been changed.'
    },
    { status: 400 }
  );

const _rtcTagQuotaExceeded = () =>
  HttpResponse.json({ code: 'QUOTA_EXCEEDED', message: 'ไม่อนุญาตให้ระบุเกินโควตา' }, { status: 400 });

export const handlers = [
  http.get(env.serverUrl + envServiceUrl + '/stores/:storeNo/product-tag/short-lived/count', countShortLivedTag),
  http.post(
    env.serverUrl + envServiceUrl + '/stores/:storeNo/product-tag/short-lived/validate',
    validateShortLivedTag
  ),
  http.post(env.serverUrl + envServiceUrl + '/stores/:storeNo/product-tag/short-lived/submit', submitShortLivedTag),
  http.post(
    env.serverUrl + envServiceUrl + '/stores/:storeNo/product-tag/promotion-tag/RTC/print-info',
    printInfoRtcTag
  ),
  http.post(
    env.serverUrl + envServiceUrl + '/stores/:storeNo/product-tag/promotion-tag/RTC/mark-printed',
    markPrintedRtcTag
  )
];
